import type { CmsABTest } from 'api/cms/abTests';

export const getCmsScaledVersion = (
  experiment: string,
  versionsNames: string[],
  cmsABTests?: CmsABTest[]
) => {
  const cmsABTestVersion = cmsABTests?.find(
    ({ title }) => title === experiment
  )?.version;

  if (cmsABTestVersion && versionsNames.includes(cmsABTestVersion)) {
    return cmsABTestVersion;
  }
};
